import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-4" }
const _hoisted_3 = { class: "col-sm-4" }
const _hoisted_4 = ["readonly"]
const _hoisted_5 = {
  key: 0,
  class: "col-sm-4 pt-2"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 mb-4" }, null, -1)
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-sm-4" }
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = { class: "row mb-3" }
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "col-sm-4" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-sm-4" }
const _hoisted_19 = { class: "col-sm-4" }
const _hoisted_20 = { class: "col-sm-4" }
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = { class: "col-sm-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "fs_12" }, "kgCO2e", -1)
const _hoisted_24 = { class: "col-sm-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "fs_12" }, "kgCO2e", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_localized_text, {
          localizedKey: "Scope",
          text: "Scope",
          class: "fw_700 d-block mb-3"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.emissionDataBase.scope), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Reference ID",
          text: "Reference ID",
          class: "fw_700 d-block mb-2"
        }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localReferenceID) = $event)),
          class: "form-control mb-3",
          readonly: _ctx.isReadOnly
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.localReferenceID]
        ])
      ]),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-tertiary mt-3",
              disabled: !_ctx.localReferenceID,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateReferenceID()))
            }, "Aggiorna reference ID", 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_localized_text, {
          localizedKey: "Year",
          text: "Year",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.year), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_localized_text, {
          localizedKey: "Month",
          text: "Month",
          class: "fw_700 d-block mb-1"
        }),
        (_ctx.activityData.month > -1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$filters.getMonthText(_ctx.activityData.month)), 1))
          : (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              localizedKey: "Year-wise",
              text: "Year-wise",
              type: "p"
            }))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_localized_text, {
          localizedKey: "Premises type",
          text: "Premises type",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.premisesType.text), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_localized_text, {
          localizedKey: "Category",
          text: "Category",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.emissionDataBase.category), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_localized_text, {
          localizedKey: "Fuel / Equipment type",
          text: "Fuel / Equipment type",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.emissionDataBase.fuelEquipmentType), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_localized_text, {
          localizedKey: "Fuel name",
          text: "Fuel name",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.emissionDataBase.fuelName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_localized_text, {
          localizedKey: "Consumption",
          text: "Consumption",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.consumption), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_localized_text, {
          localizedKey: "Unit",
          text: "Unit",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.emissionDataBase.uom), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_localized_text, {
          localizedKey: "Source",
          text: "Source",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.activityData.emissionDataBase.source), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_localized_text, {
          localizedKey: "Operational Emissions",
          text: "Operational Emissions",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.activityData.calculatedOperationalEmission)) + " ", 1),
          _hoisted_23
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_localized_text, {
          localizedKey: "Total Emissions",
          text: "Total Emissions",
          class: "fw_700 d-block mb-1"
        }),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.activityData.calculatedTotalEmission)) + " ", 1),
          _hoisted_25
        ])
      ])
    ])
  ]))
}